import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStudioDisplay1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="studio-display, xdr, imac"><path d="M21.25 3.75H2.75V15.25H21.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M9.25 15.75V20.25H14.75V15.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconStudioDisplay1;
